gsap.registerPlugin(ScrollTrigger);

const box2ListText = document.querySelectorAll('.box2-list-text')
const box2Img = document.querySelector('.box2-img')
const video3 = document.querySelector('#video3')
const video3M = document.querySelector('#video3-m')

const box3TextLeft = document.querySelector('.bottom-text-left')
const box3TextRight = document.querySelector('.bottom-text-right')

const box5InfoText1 = document.querySelector('.box5-info1_text')
const box5InfoText2 = document.querySelector('.box5-info2_text')


const videoMp4 = document.querySelectorAll(".box6-splide-video-box video");
const videoButMp4 = document.querySelectorAll(".video-but-mp4");


const numberTransition = document.querySelector('.text-number-transition')

const box7InfoSvg = document.querySelectorAll('.box7-accessories-item_info svg')
const box7InfoOpen = document.querySelectorAll('.box7-accessories-item_info-open')
const box7InfoClose = document.querySelectorAll('.box7-accessories-item_info-open .close-svg')

const videoMp4Arr = [
  'https://cdn.shopify.com/videos/c/o/v/d4b502b10eec400185fd86d9d0d4ab75.mp4',
  'https://cdn.shopify.com/videos/c/o/v/511b52380de242a6a261b8ed5322805e.mp4',
  'https://cdn.shopify.com/videos/c/o/v/03db36f3b89b458a96959f4250f98d36.mp4',
  'https://cdn.shopify.com/videos/c/o/v/7f6322a1ac994c90ab4644ae83057977.mp4'
]

videoButMp4.forEach((item,index) => {
  item.addEventListener('click', ()=>{
    item.style.display = 'none'
    videoMp4[index].src = videoMp4Arr[index]
    videoMp4[index].play()
    
    videoMp4[index].addEventListener('ended', ()=>{
      item.style.display = 'flex'
    })
    
  })
  
  
})

ScrollTrigger.create({
  trigger: '.box2-content',
  start: 'top 50%+60px',
  end:'bottom 50%+60px',
  scrub: true,
  onUpdate(self){
    let numIndex = self.progress;

    if(numIndex>0){
      box2ListText.forEach((item) => item.classList.add('animated-element'));
      box2Img.classList.add('animated-element');
    }else{
      box2ListText.forEach((item) => item.classList.remove('animated-element'));
      box2Img.classList.remove('animated-element');
    }
  }
})


ScrollTrigger.create({
  trigger: '.box3-bottom',
  start: 'top 60%',
  end:'bottom 60%',
  scrub: true,
  onEnter(){
    video3M.play()
  },
  onUpdate(self){
    let numIndex = self.progress;
    if(numIndex>0.4){
      box3TextLeft.classList.add('animated-element')
      box3TextRight.classList.add('animated-element')
    }else{
      box3TextLeft.classList.remove('animated-element')
      box3TextRight.classList.remove('animated-element')
    }
  }
})

ScrollTrigger.create({
  trigger: '.box3-bottom',
  start: 'top 60%',
  end:'bottom 60%',
  scrub: true,
  onEnter(){
    video3.play()
  },
  onUpdate(self){
    let numIndex = self.progress;
    if(numIndex>0.4){
      box3TextLeft.classList.add('animated-element')
      box3TextRight.classList.add('animated-element')
    }else{
      box3TextLeft.classList.remove('animated-element')
      box3TextRight.classList.remove('animated-element')
    }
  }
})

ScrollTrigger.create({
  trigger: '.box5-info1',
  start: 'center 80%',
  end:'bottom 80%',
  scrub: true,
  onUpdate(self){
    let numIndex = self.progress;
    if(numIndex>0){
      box5InfoText1.classList.add('animated-element')
    }else{
      box5InfoText1.classList.remove('animated-element')
    }
  }
})

ScrollTrigger.create({
  trigger: '.box5-info2',
  start: 'center 80%',
  end:'bottom 80%',
  scrub: true,
  onUpdate(self){
    let numIndex = self.progress;
    if(numIndex>0){
      box5InfoText2.classList.add('animated-element')
    }else{
      box5InfoText2.classList.remove('animated-element')
    }
  }
})

ScrollTrigger.create({
  trigger: '.box5-info3',
  start: 'center 50%',
  end:'bottom 50%',
  scrub: true,
  onUpdate(self){
    let numIndex = self.progress;
    if(numIndex>0){
      numberTransition.classList.add('animated')
    }else{
      numberTransition.classList.remove('animated')
    }
  }
})

// ScrollTrigger.create({
//   trigger: '.box7-accessories',
//   start: 'top center',
//   end:'bottom bottom',
//   scrub: true,
//   animation:
//   gsap.timeline()
//   .from('.box7-accessories-item1',{transform:'matrix(1, 0, 0, 1, 0, 200)',scale:1},)
//   .from('.box7-accessories-item2',{transform:'matrix(1, 0, 0, 1, 0, 200)',scale:1},)
//   .from('.box7-accessories-item3',{transform:'matrix(1, 0, 0, 1, 0, 200)',scale:1},)
// })


box7InfoSvg.forEach((item,index)=> {
  item.addEventListener('click',()=>{
    box7InfoOpen[index].style.display = 'block'
  })
})

box7InfoClose.forEach((item,index)=> {
  item.addEventListener('click',()=>{
    box7InfoOpen[index].style.display = 'none'
  })
})




var splide5 = new Splide( '#box6-splide', {
  focus    : 'center',
  autoWidth: true,
  breakpoints: {
    750: {
      autoWidth: false,
      autoHeight:'true',
    }
  }
} );
var splide9 = new Splide( '#box9-splide', {
  type   : 'loop',
  focus: 'center',
  autoWidth: true,
  breakpoints: {
    1920: {
      height:680,
    },
    750: {
      autoWidth: false,
      height:'auto',
    }
  },

} );

splide5.mount();
splide9.mount();
